import styled from 'styled-components'
import {ThemeColorsHospitalic} from '@/assets/styles/color/ThemeColorsHospitalic'
import {Chip, InputLabel, TableCell, TableCellProps} from '@mui/material'

export const StyledInlineContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 3em;
    margin-bottom: 2em;
`

export const StyledInlineDiv = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5em;
`

export const StyledInputLabel = styled(InputLabel)`
    color: ${ThemeColorsHospitalic.TEXT_PRIMARY};
`

export const StyledTableCell = styled(TableCell)`
    border-right: 0;
    border-left: 0;
`

export const StyledTableHeader = styled(TableCell)<TableCellProps & {$larger?: boolean; $noVerticalBorder?: boolean}>`
    font-weight: bold;
    z-index: 1;
    border-right: ${({$noVerticalBorder}) => $noVerticalBorder ? '0': ''};
    border-left: ${({$noVerticalBorder}) => $noVerticalBorder ? '0': ''};
    padding-top: ${({$larger}) => $larger ? '1.5em': ''};
    padding-bottom: ${({$larger}) => $larger ? '1.5em': ''};
`

export const StyledFilterContainer = styled.div`
    background-color: ${ThemeColorsHospitalic.NEUTRAL_MEDIUM};
    border-radius: 1em;
    padding: 1.5em;
`

export const StyledChip = styled(Chip)`
    background-color: ${ThemeColorsHospitalic.PRIMARY_LIGHT}
`

export const StyledSpaceBetweenDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2em;
`

export const StyledJsonPreview = styled.pre`
    white-space: pre-wrap;
    overflow-wrap: break-word;
`